import Vue from "vue";
import Router from "vue-router";

import SupportSection from "./views/SupportSection";
import Support from "./views/Support";
import SupportPage from "./views/SupportPage";
import Schedule from "./views/Schedule";
import Projects from "./views/Projects";
import Podcasts from "./views/Podcasts";
import Archive from "./views/Archive";
import Collections from "./views/Collections";
import SingleCollection from "./views/SingleCollection";
import Single from "./views/Single";
import Search from "./views/Search";
import Events from "./views/Events";
import About from "./views/About";
import AboutDetail from "./views/AboutDetail";
import Event from "./views/Event";
import Drive from "./views/Drive";
import Team from "./views/Team";
import Home from "./views/Home";
import Djs from "./views/Djs";
import ScheduleDetail from "./views/ScheduleDetail";
import Tv from "./views/Tv";
import Tv2 from "./views/Tv2";
import Tv3 from "./views/Tv3";
import { defaultRedirect, homeRedirect } from "./lib/redirects";

Vue.use(Router);

const contentState = { params: true, pagination: true };

const router = new Router({
  mode: "history",
  linkExactActiveClass: "active",
  routes: [
    { path: "/", component: Home, name: "home", beforeEnter: homeRedirect },
    {
      path: "/tv2",
      component: Tv2,
      name: "tv2",
      meta: { contentState },
    },
    {
      path: "/tv3",
      component: Tv3,
      name: "tv3",
      meta: { contentState },
    },
    {
      path: "/tv",
      component: Tv,
      name: "tv",
      meta: { contentState },
    },

    {
      path: "/archive",
      component: Archive,
      name: "archive",
      meta: { contentState },
    },
    {
      path: "/archive/:broadcast",
      component: Single,
      name: "broadcast",
      meta: { contentState },
    },
    {
      path: "/archive/collections",
      component: Collections,
      name: "collections",
      meta: { contentState },
    },
    {
      path: "/archive/:collection",
      component: SingleCollection,
      name: "collection",
      meta: { contentState },
    },
    {
      path: "/search/:term",
      component: Search,
      meta: { contentState: { params: true } },
    },
    {
      path: "/search",
      component: Search,
      meta: { contentState: { disable: true } },
    }, // no fetch!
    {
      path: "/events",
      component: Events,
      name: "events",
      meta: { contentState },
    },
    { path: "/events/:id/:slug", component: Event },
    { path: "/schedule", component: Schedule },
    { path: "/schedule/:id/:slug", component: ScheduleDetail, name: "schedule" },
    {
      path: "/support",
      component: SupportPage,
      name: "support",
      meta: { contentState: { disable: true } }
    },
    { path: "/supporters", component: Support, name: "supporters" },
    { path: "/about", component: About, name: "about" },
    { path: "/aboutdetail", component: AboutDetail, name: "aboutdetail" },
    {
      path: "/support/:section",
      component: SupportSection,
      name: "supportoptions",
    },
    { path: "/djs", component: Djs, name: "djs" },
    { path: "/djs/j-tripp", redirect: "/djs/j-tripp-georgia" },
    { path: "/djs/:dj", component: Single, name: "dj", meta: { contentState } },
    { path: "/shows", component: Djs, name: "shows", meta: { active: "/djs" } },
    {
      path: "/shows/:show",
      component: Single,
      name: "show",
      meta: { contentState, active: "/djs" },
    },
    { path: "/projects", component: Projects, name: "projects" },
    { path: "/podcasts", component: Podcasts, name: "podcasts" },
    { path: "/team", component: Team, name: "team" },
    { path: "/drive", component: Drive, name: "drive" },
    { path: "/takeover", component: Drive, name: "takeover" },
    { path: "/:fallback", beforeEnter: defaultRedirect, component: Single },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      // page specific
      const scrollArchive = scrollToPaginationArchive(to);
      const scrollPage = scrollToPaginationPage(to);
      const scrollDirectors = scrollToTeamSection(to);
      const scrollSupporters = scrollToSupporterSection(to);
      const scrollHistory = scrollToHistory(to);
      const scrolldei = scrollToDEISection(to);
      const scrollSponsors = scrollToSponsorsSection(to);
      const scrollOther = scrollToOtherWaysToSupport(to);
      const scrollCircle = scrollToSupporterCircle(to);
      const scrollSupportHash = scrollToSupportHash(to);
      if (scrollArchive) return scrollArchive;
      if (scrollPage) return scrollPage;
      if (scrollDirectors) return scrollDirectors;
      if (scrollSupporters) return scrollSupporters;
      if (scrollHistory) return scrollHistory;
      if (scrolldei) return scrolldei;
      if (scrollSponsors) return scrollSponsors;
      if (scrollOther) return scrollOther;
      if (scrollCircle) return scrollCircle;
      if (scrollSupportHash) return scrollSupportHash;
      // default
      return { x: 0, y: 0 };
    }
  },
});

router.beforeEach((to, from, next) => {
  // maintain 'cache_clear' query param when switching routes if present.  
  if (from.query.ignore_cache && !to.query.ignore_cache) {
    const newContext = { ...to, query: { ...to.query, ignore_cache: true } }
    next(newContext)
  } else {
    next()
  }
})

function scrollToTeamSection(route) {
  if (route.name && route.name.match(/team/g) && route.hash === "#directors") {
    const headerEl = document.querySelector(".HeaderWrap");
    const offsetEl = document.getElementById("directors");
    if (offsetEl && headerEl) {
      const headerBox = headerEl.getBoundingClientRect();
      return { x: 0, y: offsetEl.offsetTop - headerBox.height };
    }
  } else {
    return false;
  }
}

function scrollToDEISection(route) {
  if (route.name && route.name.match(/aboutdetail/g) && route.hash === "#dei") {
    const headerEl = document.querySelector(".HeaderWrap");
    const offsetEl = document.getElementById("dei");
    if (offsetEl && headerEl) {
      const headerBox = headerEl.getBoundingClientRect();
      return { x: 0, y: offsetEl.offsetTop - headerBox.height };
    }
  } else {
    return false;
  }
}

function scrollToSupporterSection(route) {
  if (route.name && route.name.match(/team/g) && route.hash === "#supporters") {
    const headerEl = document.querySelector(".HeaderWrap");
    const offsetEl = document.getElementById("supporters");
    if (offsetEl && headerEl) {
      const headerBox = headerEl.getBoundingClientRect();
      return { x: 0, y: offsetEl.offsetTop - headerBox.height };
    }
  } else {
    return false;
  }
}

function scrollToSponsorsSection(route) {
  if (route.name && route.name.match(/support/g) && route.hash === "#sponsor") {
    const headerEl = document.querySelector(".HeaderWrap");
    const offsetEl = document.getElementById("sponsor");
    if (offsetEl && headerEl) {
      const headerBox = headerEl.getBoundingClientRect();
      return { x: 0, y: offsetEl.offsetTop - headerBox.height };
    }
  } else {
    return false;
  }
}

function scrollToHistory(route) {
  if (
    route.name &&
    route.name.match(/aboutdetail/g) &&
    route.hash === "#history"
  ) {
    const headerEl = document.querySelector(".HeaderWrap");
    const offsetEl = document.getElementById("history");
    if (offsetEl && headerEl) {
      const headerBox = headerEl.getBoundingClientRect();
      return { x: 0, y: offsetEl.offsetTop - headerBox.height };
    }
  } else {
    return false;
  }
}

function scrollToOtherWaysToSupport(route) {
  if (route.name && route.name.match(/support/g) && route.hash === "#other") {
    const headerEl = document.querySelector(".HeaderWrap");
    const offsetEl = document.getElementById("other");
    if (offsetEl && headerEl) {
      const headerBox = headerEl.getBoundingClientRect();
      return { x: 0, y: offsetEl.offsetTop - headerBox.height };
    }
  } else {
    return false;
  }
}

function scrollToSupporterCircle(route) {
  if (route.name && route.name.match(/support/g) && route.hash === "#supporter-circle") {
    const headerEl = document.querySelector(".HeaderWrap");
    const offsetEl = document.getElementById("supporter-circle");
    if (offsetEl && headerEl) {
      const headerBox = headerEl.getBoundingClientRect();
      return { x: 0, y: offsetEl.offsetTop - headerBox.height };
    }
  } else {
    return false;
  }
}

function scrollToSupportHash(route) {
  // Generic handler for support page anchor links
  if (route.name && route.name.match(/support/g) && route.hash) {
    const validHashes = ['#major-donors', '#partners-sponsors', '#other-ways-to-give', '#volunteer-with-us'];
    if (validHashes.includes(route.hash)) {
      const headerEl = document.querySelector(".HeaderWrap");
      const offsetEl = document.getElementById(route.hash.substring(1));
      if (offsetEl && headerEl) {
        const headerBox = headerEl.getBoundingClientRect();
        return { x: 0, y: offsetEl.offsetTop - headerBox.height };
      }
    }
  }
  return false;
}



function scrollToPaginationArchive(route) {
  if (
    route.name &&
    route.name.match(/archive|events/g) &&
    Object.keys(route.query).length > 0
  ) {
    const headerEl = document.querySelector(".HeaderWrap");
    // on /events a `?day=` selection renders the day's events above the
    // calendars, so scroll to those rather than past them
    const offsetEl =
      document.querySelector(".select") ||
      document.querySelector(".day-filter") ||
      document.querySelector(".calendars");
    if (offsetEl && headerEl) {
      const headerBox = headerEl.getBoundingClientRect();
      return { x: 0, y: offsetEl.offsetTop - headerBox.height };
    }
  } else {
    return false;
  }
}

function scrollToPaginationPage(route) {
  if (
    route.name &&
    route.name.match(/broadcast|show|dj/g) &&
    Object.keys(route.query).length > 0
  ) {
    const headerEl = document.querySelector(".HeaderWrap");
    const offsetEl = document.querySelector("[data-scroll-target]");
    if (offsetEl && headerEl) {
      const headerBox = headerEl.getBoundingClientRect();
      return { x: 0, y: offsetEl.offsetTop - headerBox.height };
    }
  } else {
    return false;
  }
}

export default router;